export const EN = {
  BASE_URL: "https://api.motorevents.com.au/api",
  proxy_Url: "https://cors-anywhere.herokuapp.com/",
  sign_in: "SIGN IN",
  save: "Save",
  ADD_LICENSE: "+ Add",
  cancel: "Cancel",
  send: "Send",
  select: "Select",
  show_the_team: "Show the Team",
  create_account: "Create Account",
  approve: "Approve",
  delete: "Delete",
  logout: "Logout",
  hereAboutUs: [
    "How do you know about us?",
    "Search engine",
    "Facebook",
    "Friend",
    "Instagram",
    "Event",
    "Forum",
    "Advert",
    "Other",
  ],
  message: {
    register: "Registration complete, check please email to verify account.",
    forgot_password: "Check please email to enter new password.",
    create_team: "You have successfully created team",
    update_team: "You have successfully updated team",
    send_invitation: "Invitation sent to this email",
    join_team: "You successfully join to this team",
    pay_for_slot: "You have successfully paid for this slot",
    pay_for_slots: "You have successfully paid for drivers and crews",
    re_create_team: "You reactivated this team",
  },
  modification_points_used: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  role: ["Driver", "Crew"],
};

export const fontStyle = {
  fontSize: "16px",
  fontFamily: "Segoe UI",
  fontWeight: 700,
  color: "#E00000",
  marginBottom: 10,
  background: "none",
  textShadow: "none",
};
export const fontStyleHeading = {
  fontSize: "20px",
  fontFamily: "Segoe UI",
  fontWeight: 700,
  color: "#E00000",
};
export const fontStyleBlack = {
  fontSize: "16px",
  fontFamily: "Segoe UI",
  fontWeight: 700,
  color: "#00000",
};
export const fontStyleBlackHeading = {
  fontSize: "20px",
  fontFamily: "Segoe UI",
  fontWeight: 700,
  color: "#00000",
};
export const fontStyleRedEventProfile = {
  fontSize: "24px",
  fontFamily: "Segoe UI",
  fontWeight: 700,
  color: "#E00000",
};
export const iconColor = {
  color: "#E00000",
};
export const fontStyleHeadingProfile = {
  fontSize: "18px",
  fontFamily: "Segoe UI",
  fontWeight: 700,
  color: "#E00000",
  marginBottom: 10,
  padding: "10px",
  borderBottom: "1px solid #DCDCDC",
};

export const ALL_LICENSE_TYPES = ["AASA", "RACERS"];
